namespace Matrix.Data {

	@Serenity.Decorators.responsive()
	@Serenity.Decorators.panel()
	export class SingleAccountHoldingDialog extends Serenity.TemplatedDialog<any> {

        public grid: SingleAccountHoldingGrid;

        constructor() {
            super();

			this.grid = new SingleAccountHoldingGrid(this.element.children());
        }

        protected getTemplate() {
			return "<div style='height: 100%; flex: 1 1 100%;'></div>";
        }
    }
}